import React from "react";
import { getFieldPath } from "utils/form";
import FormActions from "components/FormActions";
import SectionBezel from "components/SectionBezel";
import CheckoutPricePickers from "components/CheckoutPricePickers";
import HoverIconButton from "components/HoverIconButton";
import { useCtxReferences } from "utils/selectors";
import { interpolateRouteWithParams } from "utils/route";
import Link from "next/link";
import PATHS from "utils/paths";
import { TOOLTIP_POSITION } from "utils/constants/ui";
import PresentLayout from "components/PresentLayout";
import ImagesFields from "components/ProductForm/Fields/Images";
import ConnectedTextarea from "components/ConnectedTextarea";

const ProductNew = ({ name, header, innerNameRef }) => {
  const nameFieldPath = getFieldPath(name, "name");
  const descriptionFieldPath = getFieldPath(name, "description");
  const pricesFieldPath = getFieldPath(name, "prices");

  const { application } = useCtxReferences();
  const backDestination = interpolateRouteWithParams(
    PATHS.HUB_APPLICATIONS_PRODUCTS,
    {
      application
    }
  );
  const presentProps = {};
  presentProps.header = (
    <FormActions
      theme="slim"
      customClasses={{
        container: "w-100 flex flex-row justify-between items-center"
      }}
    >
      {header || (
        <div className="flex justify-between items-center">
          <Link href={backDestination}>
            <div className="flex flex-row items-center pointer">
              <HoverIconButton
                type="back"
                tooltip="All products"
                tooltipPosition={TOOLTIP_POSITION.RIGHT}
              />
              <div className="pl1 f6 fw5 pointer">Back</div>
            </div>
          </Link>
        </div>
      )}
    </FormActions>
  );
  presentProps.content = [
    <ImagesFields name={name} />,
    <SectionBezel header="Details">
      <ConnectedTextarea
        name={nameFieldPath}
        label="Name"
        minRows={1}
        placeholder="Name is required"
      />
      <div className="pt3">
        <ConnectedTextarea
          name={descriptionFieldPath}
          label="Description"
          minRows={1}
          placeholder="Description is optional"
        />
      </div>
    </SectionBezel>,
    <SectionBezel header="Prices">
      <CheckoutPricePickers name={pricesFieldPath} />
    </SectionBezel>
  ].map((node, nodeIx) => (
    <div className="pt3 pt4-ns" key={nodeIx}>
      {node}
    </div>
  ));

  return <PresentLayout {...presentProps} mobileTop={0} />;
};

export default ProductNew;
